import { render, staticRenderFns } from "./UserAssignments.vue?vue&type=template&id=169f8c8a&scoped=true&"
import script from "./UserAssignments.vue?vue&type=script&lang=ts&"
export * from "./UserAssignments.vue?vue&type=script&lang=ts&"
import style0 from "./UserAssignments.vue?vue&type=style&index=0&id=169f8c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f8c8a",
  null
  
)

export default component.exports